import { Constants, ShowTypes } from "@eagerdog/constants";
import { IEventRegisterRow } from "../../../services/helper.service.js";
import { IShow } from "@eagerdog/interfaces";

/**
 * CKC Scent Detection entry form (CKC Scent Detection Trial Rules & Regulations, 2024).
 * One checkbox row per component the club offers (6.8.2: Container, Interior, Exterior),
 * listing the classes the club checked under that component (6.8.1: Instinct, Novice, Open,
 * Excellent, Master). Instinct exists only in Container (9.6.2). A dog may be entered at a
 * different class in each component (10.1.1, 10.1.11), so no class excludes another.
 */
export namespace CKCScentDetection {
  const ckcScent: Record<string, string[]> =
    ShowTypes[Constants.sanctioning_club.CKC][Constants.show_type.scent_detection];

  /** Components in the order they appear on the CKC entry form. */
  export const components: string[] = Object.keys(ckcScent);

  /** Classes a component can offer, in form order. */
  export const classesFor = (component: string): string[] => ckcScent[component] || [];

  export const getForm = (show?: IShow): IEventRegisterRow[] => {
    const isOffered = (component: string, level: string): boolean => {
      if (!show?.show_elements) return true;

      return show.show_elements.some((se) =>
        se.show_element === component && se.level === level
      );
    };

    const toOption = (level: string) => ({ value: level, id: level });

    const formRows: IEventRegisterRow[] = [];

    for (const component of components) {
      const options = classesFor(component)
        .filter((level) => isOffered(component, level))
        .map(toOption);

      if (options.length > 0) {
        formRows.push({
          allowDuplicates: false,
          inputs: [
            {
              type: "checkbox",
              label: component,
              multiSelect: true,
              columnLayout: true,
              options,
            },
          ],
        });
      }
    }

    return formRows;
  };
}
